import { useQuery } from "@tanstack/react-query";
import { apiRelProdutorFaixaLitragem } from "pages/relatorios/api/apiRelProdutorFaixaLitragem";
import { RelatorioContainer } from "pages/relatorios/components/RelatorioContainer";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioGetParams } from "pages/relatorios/types/ApiRelatorioParams";
import { buildRelatorioGetParams } from "pages/relatorios/utils/buildRelatorioGetParams";
import type { ApiRelProdutorFaixaLitragem } from "pages/relatorios/types/ApiRelProdutorFaixaLitragem";
import { useEffect, useMemo } from "react";
import type { TExportToCSV } from "std/csv";
import { FilterBarProdutorFaixaLitragem } from "./FilterBar";
import { TableRelProdutorFaixaLitragem } from "./TableRelProdutorFaixaLitragem";

export function RelatorioProdutorFaixaLitragem() {
	const filter = useRelatorioStore((s) => s.filter);
	const limparFiltros = useRelatorioStore((s) => s.limparFiltros);

	const params: ApiRelatorioGetParams = useMemo(() => buildRelatorioGetParams(filter), [filter]);

	const { data, isFetching, refetch } = useQuery({
		queryKey: ["apiRelProdutorFaixaLitragem", params],
		queryFn: () => apiRelProdutorFaixaLitragem({ params }),
		enabled: false,
	});

	const registros = useMemo(() => data?.registros || [], [data]);

	// Se quiser CSV simples (um registro por produtor)
	const csvData: TExportToCSV<ApiRelProdutorFaixaLitragem, never> | undefined = useMemo(() => {
		return {
			type: "simple", // ajuste esse 'simple' caso seu TExportToCSV use outro identificador
			fileName: "relatorio-produtor-faixa-litragem",
			options: {
				columns: [
					{ key: "produtorCodigo", title: "Código" },
					{ key: "produtorNome", title: "Produtor" },
					{ key: "rotaIdentificacao", title: "Rota" },
					{ key: "totalVolume", title: "Volume Total (L)" },
				],
				data: registros,
			},
		} as any;
	}, [registros]);

	useEffect(() => {
		limparFiltros();
	}, [limparFiltros]);

	const title = "Relatório % de Produtores por Faixa de Litragem";

	return (
		<RelatorioContainer
			breadCrumbs={["Relatórios", "Litragem", "% Produtor por Faixa"]}
			refetch={refetch}
			filterBar={<FilterBarProdutorFaixaLitragem />}
			loading={isFetching}
			title={title}
			csvData={csvData}
			registros={registros}
			table={<TableRelProdutorFaixaLitragem registros={registros} title={title} />}
		/>
	);
}
